<script setup lang="ts">
defineProps<{
  text?: string
}>()
</script>

<template>
  <div class="flex w-full items-center">
    <div v-if="text" class="pr-5 text-black-400">
      {{ text }}
    </div>
    <div class="h-0 flex-1 border-b border-dotted border-b-black-300"></div>
  </div>
</template>
